import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import {
  IChatAutoCleanupSettingsProps,
  useChatAutoCleanupSettingsPresenter,
} from './ChatAutoCleanupSettings.presenter';
import styles from './ChatAutoCleanupSettings.styles.m.css';
import { ChatAutoCleanupSettingsItem } from './ChatAutoCleanupSettingsItem/ChatAutoCleanupSettingsItem';

export const ChatAutoCleanupSettings: FC<IChatAutoCleanupSettingsProps> = observer((props) => {
  const presenter = useChatAutoCleanupSettingsPresenter(props);

  return (
    <div className={styles.container}>
      {presenter.settingsItems.map((item) => (
        <ChatAutoCleanupSettingsItem
          onChange={props.onChange}
          isActive={props.value === item.value}
          key={item.key}
          title={item.title}
          value={item.value}
        />
      ))}
    </div>
  );
});
